export default [
    {
        path: "/components/text-editor/",
        component: () => import("@/components/external/ExternalTextEditor"),
        meta: {
            hideUI: true,
        },
    },
];
